import { createStyles, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-evenly',
      '& button': {
        textTransform: 'none'
      },
      '& button:hover': {
        backgroundColor: 'inherit',
        textShadow: '0px 0px 1px #1F1F1F',
        borderTopLeftRadius: 'unset',
        borderBottomLeftRadius: 'unset'
      },
      '& button:not(:first-child)': {
        borderLeft: '1px solid #c0c0c0'
      }
    }
  })
)
